var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2862 17.7375C10.0638 17.7375 9.86619 17.6881 9.69326 17.5893C9.52033 17.4905 9.35564 17.3423 9.19918 17.1446L6.3088 13.5996C6.10293 13.3443 6 13.0808 6 12.8091C6 12.5209 6.09676 12.2759 6.29027 12.0741C6.48379 11.8724 6.72465 11.7715 7.01287 11.7715C7.1858 11.7715 7.34431 11.8086 7.48842 11.8827C7.63253 11.9568 7.77458 12.0885 7.91457 12.2779L10.2367 15.2424L15.1405 7.37419C15.3793 6.98716 15.6758 6.79364 16.0299 6.79364C16.3016 6.79364 16.5466 6.88216 16.7648 7.05921C16.983 7.23625 17.0921 7.46888 17.0921 7.7571C17.0921 7.88885 17.0612 8.02267 16.9995 8.15854C16.9377 8.29441 16.8657 8.42411 16.7833 8.54763L11.3114 17.1323C11.0561 17.5358 10.7144 17.7375 10.2862 17.7375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteSquare);
export default __webpack_public_path__ + "static/media/complete-square.ee0e42daf55e0e044bfd7c9a5faaf0df.svg";
export { ForwardRef as ReactComponent };